/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Models_DescriptionInputs */

const en_directory_models_description = /** @type {(inputs: Directory_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan leading language, image, video, and audio models by provider, use case, and disclosed starting price.`)
};

const zh_directory_models_description = /** @type {(inputs: Directory_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按服务商、使用场景和已披露的起始价格，浏览主流语言、图像、视频与音频模型。`)
};

/**
* | output |
* | --- |
* | "Scan leading language, image, video, and audio models by provider, use case, and disclosed starting price." |
*
* @param {Directory_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_description = /** @type {((inputs?: Directory_Models_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_description(inputs)
	return zh_directory_models_description(inputs)
});
export { directory_models_description as "directory.models.description" }